import React, { useState } from 'react'
import ReactPlayer from 'react-player'
import {makeStyles} from '@mui/styles';

import Preloader from '../Preloader/Preloader';

const useStyles = makeStyles(() => ({
	// card wrapper
	videoWrapper: {
		position: 'relative',
		minHeight: '250px',
		width: '100%',
		"&:before": {
			content: '""',
			display: 'block',
			paddingBottom: '50%'
		},
		'@media (min-width: 1800px)': {
			"&:before": {
				paddingBottom: '70%'
	 		},
		},
		'@media (max-width: 1024px)': {
			"&:before": {
				paddingBottom: '50%'
	 		},
		},
	},
	player: {
		position: 'absolute',
		top: '0px',
		left: '0px',
		height: '100%',
		width: '100%',
		overflow: 'hidden'
	},

}));

const Player = ({url}) => {
	const [loader, setLoader] = useState(true);
	const classes = useStyles();

	return (
		<div className={classes.videoWrapper}>
			{loader && <Preloader/>}
			<ReactPlayer
				onReady={() => setLoader(false)}
				className={classes.player}
				url={url}
				height="100%"
				width="100%"
				controls="true"
			/>
		</div>
	)
}

export default Player;